'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = require('./components/Checkbox.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-checkbox/lib/index.js
// module id = 1014
// module chunks = 0